export const culturalNewsletter=[
  {
    "displayText": "Blood Donation",
    "filename": "./assets/documentation/newsletter/cultural/Blood Donation.pdf",
    "link": ""
  },
  {
    "displayText": "CULTURAL & SPORT WEEK NEWS",
    "filename": "./assets/documentation/newsletter/cultural/CULTURAL & SPORT WEEK NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "FRESHERS PARTY",
    "filename": "./assets/documentation/newsletter/cultural/FRESHERS PARTY.pdf",
    "link": ""
  },
  {
    "displayText": "GANPATI FESTIVAL NEWS",
    "filename": "./assets/documentation/newsletter/cultural/GANPATI FESTIVAL NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "HAR GHAR TIRANGA NEWS",
    "filename": "./assets/documentation/newsletter/cultural/HAR GHAR TIRANGA NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "INDUCTION PROGRAMME NEWS",
    "filename": "./assets/documentation/newsletter/cultural/INDUCTION PROGRAMME NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "PALAVI VISIT NEWS",
    "filename": "./assets/documentation/newsletter/cultural/PALAVI VISIT NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "QUIZ COMPETITION FIRST PRIZE",
    "filename": "./assets/documentation/newsletter/cultural/QUIZ COMPETITION FIRST PRIZE.pdf",
    "link": ""
  },
  {
    "displayText": "SWACHATA ABHIYAN NEWS",
    "filename": "./assets/documentation/newsletter/cultural/SWACHATA ABHIYAN NEWS.pdf",
    "link": ""
  }
]